import ThumbUpRoundedIcon from '@mui/icons-material/ThumbUpRounded';
import { Button, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * The view to show when the password reset has been successful
 */
const ResetSuccessful = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <ThumbUpRoundedIcon
        color="success"
        sx={{ fontSize: '4em', marginY: '.25em' }}
      />
      <Typography
        variant="h1"
        fontSize="1.5em"
        fontWeight="bold"
        gutterBottom
        textAlign="center"
      >
        Password Reset Successful!
      </Typography>
      <Typography
        color={theme.palette.text.secondary}
        textAlign="center"
        sx={{ maxWidth: '90%', marginBottom: '2em' }}
      >
        We have successfully reset your password. Please navigate to the login
        page to access the training with your new password!
      </Typography>
      <Button onClick={() => navigate('/login')} fullWidth variant="contained">
        To login page
      </Button>
    </>
  );
};

export default ResetSuccessful;
